import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  Heading,
  PositiveNumberField,
  RadioButton
} from '@superops/ui-design-system';

import { ServiceCatalogItem } from '../../types';
import { ServiceCatalogFormContext } from '../index';
import { ServiceItemsDropdown, SelectedServiceItems } from '../../Components';
import { Column,CurrencyField } from '@nile/components';

function BlockMoneyTypeItem({
  removeBundledItem,
  handleBundledItems,
  selectedCatalogItem,
  handlePropertyChange,
  disableServiceCatalogItemCostAndPrice
}: {
  handleBundledItems: (item) => void;
  removeBundledItem: (itemId) => void;
  selectedCatalogItem: ServiceCatalogItem;
  handlePropertyChange: (key, val) => void;
  disableServiceCatalogItemCostAndPrice: boolean;
}) {
  const { errors, validate, currencyValue, currencyCode } = useContext(
    ServiceCatalogFormContext
  );

  function handleChange(key) {
    return (value) => {
      const updatedServiceTypeItem = {
        ...selectedCatalogItem?.serviceTypeItem,
        redeemableServiceBundle: {
          ...selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle,
          [key]: value
        }
      };
      if (value === 'ALL_ITEMS') {
        updatedServiceTypeItem.bundledItems = [];
      }
      handlePropertyChange('serviceTypeItem', updatedServiceTypeItem);

      // If applicableType is changed we validate again to remove bundle(service) item required error.
      if (key === 'applicableType')
        validate({
          ...selectedCatalogItem,
          serviceTypeItem: updatedServiceTypeItem
        });
    };
  }

  return (
    <div className="grid g20">
      <CurrencyField
        type="number"
        label={
          <>
            <FormattedMessage id="client.contracts.queue.blockMoney.quantity" />
            :
          </>
        }
        value={selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle?.redeemableQuantity?.toString()}
        placeholder="0"
        // suffix={`${currencyValue}${currencyCode}`}
        autoComplete="off"
        onChange={handleChange('redeemableQuantity')}
        size="small"
        error={
          errors?.[
            'serviceTypeItem.redeemableServiceBundle.redeemableQuantity'
          ]?.[0] && <FormattedMessage id="field.amount.blank.error" />
        }
        disabled={disableServiceCatalogItemCostAndPrice}
        showCurrency
        currencyInPrefix={false}
      />
      <Heading element="h6">
        <FormattedMessage id="admin.serviceCatalog.applicableIn.placeholder" />
      </Heading>
      <div className="fx actr g10">
        <RadioButton
          checked={
            selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle
              ?.applicableHours === 'ALL_HOURS'
          }
          label={
            <FormattedMessage id="admin.serviceCatalog.blockHourTypes.allHours" />
          }
          id="ALL_HOURS"
          onChange={(checked, id) =>
            checked && handleChange('applicableHours')(id)
          }
          disabled={disableServiceCatalogItemCostAndPrice}
        />
        <RadioButton
          checked={
            selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle
              ?.applicableHours === 'BUSINESS_HOURS'
          }
          label={
            <FormattedMessage id="admin.serviceCatalog.blockHourTypes.businessHours" />
          }
          id="BUSINESS_HOURS"
          onChange={(checked, id) =>
            checked && handleChange('applicableHours')(id)
          }
          disabled={disableServiceCatalogItemCostAndPrice}
        />
      </div>

      <Column className="mt20" gap={10}>
        <Heading element="h5">
          <FormattedMessage id="Usage" />
        </Heading>

        <RadioButton
          checked={
            selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle
              ?.applicableType === 'ALL_ITEMS'
          }
          label={
            <FormattedMessage id="admin.serviceCatalog.offeringType.package.all.items" />
          }
          id="ALL_ITEMS"
          onChange={(checked, id) =>
            checked && handleChange('applicableType')(id)
          }
          disabled={disableServiceCatalogItemCostAndPrice}
        />
        <div className="fx actr g10">
          <RadioButton
            checked={
              selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle
                ?.applicableType === 'INCLUDED_ITEMS'
            }
            id="INCLUDED_ITEMS"
            label={
              <FormattedMessage id="admin.serviceCatalog.offeringType.package.included.items" />
            }
            onChange={(checked, id) =>
              checked && handleChange('applicableType')(id)
            }
            disabled={disableServiceCatalogItemCostAndPrice}
          />
          <ServiceItemsDropdown
            offerItemType="BLOCK_MONEY"
            onChange={handleBundledItems}
            filterServiceItems={
              selectedCatalogItem?.serviceTypeItem?.bundledItems || []
            }
            isDisabled={
              selectedCatalogItem?.serviceTypeItem?.redeemableServiceBundle
                ?.applicableType === 'ALL_ITEMS' ||
              disableServiceCatalogItemCostAndPrice
            }
          />
        </div>
        <SelectedServiceItems
          selectedServiceItems={
            selectedCatalogItem?.serviceTypeItem?.bundledItems
          }
          onDeleteHandler={removeBundledItem}
          isDisabled={disableServiceCatalogItemCostAndPrice}
        />
      </Column>
    </div>
  );
}

export default BlockMoneyTypeItem;
